import SideMenu from "../../features/sideMenu/SideMenu";
import FormStepper from "../../features/stepper/Stepper";
import { itemsProjects } from "../../constants/projects";
import "./CreateProject.responsive.css";
import { useSearchParams } from "react-router-dom";
import { useState, useEffect } from "react";

const CreateProject = ({
  API_URL,
  clients,
  projects,
  typeWorks,
  permisionarios,
  states,
  user,
  setProjects,
  setClients,
  setPermisionarios,
}) => {
  const [searchParams] = useSearchParams();
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    if (!projects || projects.length === 0) return;

    const id = searchParams.get("proyecto");
    if (id) {
      const proyecto = projects.find((p) => p.id === parseInt(id));
      if (proyecto) {
        setFullData({
          estado: null,
          permisionario: null,
          cliente: null,
          proyecto,
          nombre: "",
          direccion: "",
          latitude: null,
          longitude: null,
          rpu: "",
          divisionCFE: null,
          zonaCFE: null,
          tipoTrabajo: null,
          soporteRegionalCFE: false,
          nivelTension: null,
          demandaContratada: null,
          puntoCarga: "",
          clienteId: null,
          permisionarioId: null,
        });
      } else {
        setFullData({
          estado: null,
          permisionario: null,
          cliente: null,
          proyecto: null,
          nombre: "",
          direccion: "",
          latitude: null,
          longitude: null,
          rpu: "",
          divisionCFE: null,
          zonaCFE: null,
          tipoTrabajo: null,
          soporteRegionalCFE: false,
          nivelTension: null,
          demandaContratada: null,
          puntoCarga: "",
          clienteId: null,
          permisionarioId: null,
        });
      }
    } else {
      setFullData({
        estado: null,
        permisionario: null,
        cliente: null,
        proyecto: null,
        nombre: "",
        direccion: "",
        latitude: null,
        longitude: null,
        rpu: "",
        divisionCFE: null,
        zonaCFE: null,
        tipoTrabajo: null,
        soporteRegionalCFE: false,
        nivelTension: null,
        demandaContratada: null,
        puntoCarga: "",
        clienteId: null,
        permisionarioId: null,
      });
    }
  }, [projects]);

  return (
    <div className="cp-container" style={{ display: "flex", height: "100%" }}>
      <div className="cp-sidebar" style={{ width: "12rem" }}>
        <SideMenu items={itemsProjects} />
      </div>
      <div className="cp-main" style={{ flex: 1 }}>
        {fullData && (
          <FormStepper
            clients={clients}
            projects={projects}
            typeWorks={typeWorks}
            permisionarios={permisionarios}
            API_URL={API_URL}
            states={states}
            user={user}
            setProjects={setProjects}
            setClients={setClients}
            setPermisionarios={setPermisionarios}
            proyecto={fullData}
          />
        )}
      </div>
    </div>
  );
};

export default CreateProject;
